import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  NotificationPreviewData,
  NotificationTemplate,
} from '../../../../../core/models/notification.model';

@Component({
  selector: 'irembogov-notification-configuration-preview',
  templateUrl: './notification-configuration-preview.component.html',
  styleUrls: ['./notification-configuration-preview.component.scss'],
})
export class NotificationConfigurationPreviewComponent implements OnChanges {
  @Input() locale = 'en-US';
  @Input() data: NotificationPreviewData | null = null;
  @Input() isEmail = false;
  @Input() template: NotificationTemplate | null = null;

  content = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      if (this.template) {
        this.onPreviewTemplate(this.template);
      }
    }
  }

  onPreviewTemplate(template: NotificationTemplate) {
    if (template) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(template.template, 'text/html');

      if (this.data) {
        this.content = doc.documentElement.outerHTML;

        const { title, message } = this.data[this.locale];

        if (title) {
          this.content = this.content.replace('${title}', title);
        }
        if (message) {
          this.content = this.content.replace('${message}', message);
        }

        this.content = this.content.replace(
          '${year}',
          new Date().getFullYear().toString()
        );
      }
    }
  }
}
